var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRouteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6.38,
  y: 9.7,
  width: 2.34,
  height: 0.75
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m14.08,6.46l3.62,3.62-3.62,3.62-3.62-3.62,3.62-3.62m0-1.06l-4.68,4.68,4.68,4.68,4.68-4.68-4.68-4.68h0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m3.35,8.74l1.34,1.34-1.34,1.34-1.34-1.34,1.34-1.34m0-1.06l-2.4,2.4,2.4,2.4,2.4-2.4-2.4-2.4h0Z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 12.93,
  y: 8.93,
  width: 2.3,
  height: 2.3,
  transform: "translate(-3 12.91) rotate(-45)"
})));
export default SvgRouteIcon;